export default function bindActionType(actionType, fn) {
  Object.defineProperty(fn, 'toString', {
    value: function value() {
      return actionType;
    },
    configurable: false,
    writable: false
  });
  return fn;
}